import { StateSchema } from 'app/config/storeConfig/types';
import { CreateUserParams } from 'entities/User';

export const getUserData = (state: StateSchema): Nullable<CreateUserParams> => state.createUserModal.userData;
